import Vue from 'vue'
import moment from 'moment'

Vue.filter('timeStampNow', (value, format = 'DD/MM/YYYY HH:mm:ss') => {
  return value ? moment(value).locale('pt-br').fromNow() : ''
})



// WEBPACK FOOTER //
// ./src/filters/timeStampFromNowFilter.js